export class GetFeatures {
  static readonly type = '[Features] Get Features';
  constructor() {}
}
